import React, { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import CircularProgress from "@material-ui/core/CircularProgress";
import { changeTitleName, changePdfFileName, changeIndication } from "../../../redux/actions/emailAction";
import { fetchDiuoByDoss } from "../../../redux/actions/diuoActions";
import { fetchRJ } from "../../../redux/actions/rjActions";
import { getDiuoValidation, validateDiuo, genDiuoPDF, getDiuoFile, deleteDiuo } from "../Utils";
import { Button } from "@material-ui/core";
import { PictureAsPdf as PdfIcon, Visibility as VisibilityIcon, Delete as DeleteIcon, CheckCircle as OkIcon } from "@material-ui/icons";
import Header from "../../Header/Header";
import DocMenu from "../../DocMenu";
import NumDossDIUO from "../../NumDossDIUO";
import YesNoDialog from "../../YesNoDialog";
import GenPdf from "../../GenPdf";
import "../../../Styles/DIUO/Validation.scss";

const DiuoPage10 = () => {
  const dispatch = useDispatch();
  const dossierValue = useSelector((state) => state.devis.dossierValue);
  const index = useSelector((state) => state.diuo.index);
  const diuoValue = useSelector((state) => state.diuo.diuoValue);

  const [validation, setValidation] = useState(null);
  const [disableButton, setDisableButton] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [openValidateDialog, setOpenValidateDialog] = useState(false);

  const [isOpen, setIsOpen] = useState(false);
  const [file, setFile] = useState(null);


  const getValidation = async () => {
    const response = await getDiuoValidation(diuoValue);
    if (response) {
      setValidation(response.validation);
    }
  };

  useEffect(() => {
    if (diuoValue) {
      getValidation();
    }
  }, [diuoValue]);

  const handleValidateDiuo = async () => {
    setDisableButton(true);
    try {
      const result = await validateDiuo(dossierValue, diuoValue);
      if (result.success) {
        await getValidation();
      }
    } catch (err) {
      console.error("Erreur lors de la validation du DIUO :", err.message);
    } finally {
      await dispatch(fetchRJ(dossierValue));
      setDisableButton(false);
      setOpenValidateDialog(false);
    }
  };

  const handleDeleteDiuo = async () => {
    setOpenDialog(false);
    setDisableButton(true);
    try {
      const result = await deleteDiuo(dossierValue, index, diuoValue);
      if (result.success) {
        dispatch(fetchDiuoByDoss(dossierValue));
      }
    } catch (err) {
      console.error("Erreur lors de la suppression du DIUO :", err.message);
    } finally {
      setDisableButton(false);
    }
  }

  const handleGenClick = useCallback(async () => {
    setDisableButton(true);
    setFile(null);
    let blob = await genDiuoPDF(diuoValue, dossierValue, index);
    if (blob) {
      setIsOpen(true);
      setFile(blob);
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
    setDisableButton(false);
  }, [diuoValue]);

  const handleShowPdf = useCallback(async () => {
    setDisableButton(true);
    setFile(null);
    let response = await getDiuoFile(dossierValue, index, 'pdf');
    if (response.blob.size > 100) {
      setFile(response.blob);
      setIsOpen(true);
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
    setDisableButton(false);
  }, [diuoValue]);

  const handleGetPdfFile = useCallback(async () => {
    setDisableButton(true);
    setFile(null);
    let response = await getDiuoFile(dossierValue, index, 'pdf');
    if (response.blob.type === 'application/pdf') {
      setFile(response.blob);
      const fileName = response.fileName;
      dispatch(changePdfFileName(fileName))
    }
    setDisableButton(false);
  }, [diuoValue]);

  const handleGetWordFile = useCallback(async () => {
    setDisableButton(true);
    setFile(null);
    let response = await getDiuoFile(dossierValue, index, 'word');
    if (response.blob.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
      setFile(response.blob);
      const fileName = response.fileName;
      dispatch(changePdfFileName(fileName))
    }
    setDisableButton(false);
  }, [diuoValue]);

  const handleChangeTitleName = useCallback(() => {
    dispatch(changeTitleName(`DIUO`));
  }, [diuoValue]);

  return (
    <>
      <div className="diuo-validation">
        <Header />
        <DocMenu
          file={file}
          getSourceFile={handleGetWordFile}
          getPDF={handleGetPdfFile}
          handleChangeTitleName={handleChangeTitleName}
          updateIndication={() => dispatch(changeIndication(index))}
        />
        <h1 className="title">DIUO (Validation)</h1>
        <NumDossDIUO />
        <div className="buttons-container">
          <Button
            color="primary"
            variant="contained"
            startIcon={<PdfIcon />}
            onClick={handleGenClick}
            disabled={disableButton || !diuoValue}
          >
            Générer
          </Button>
          <Button
            color="primary"
            variant="contained"
            startIcon={<VisibilityIcon />}
            onClick={handleShowPdf}
            disabled={disableButton || !diuoValue}
          >
            Afficher
          </Button>
          <Button
            color="primary"
            variant="contained"
            startIcon={<OkIcon />}
            onClick={() => setOpenValidateDialog(true)}
            disabled={disableButton || !diuoValue || !!validation}
          >
            Archiver
          </Button>
          <Button
            color="primary"
            variant="contained"
            startIcon={<DeleteIcon />}
            onClick={() => setOpenDialog(true)}
            style={{ backgroundColor: (disableButton || !diuoValue) ? "" : "red" }}
            disabled={disableButton || !diuoValue}
          >
            Supprimer
          </Button>
          {disableButton && (
            <CircularProgress className="spinner" color="inherit" />
          )}
        </div>
        <GenPdf
          file={file}
          isOpen={isOpen}
          closeDoc={() => setIsOpen(false)}
          scale={1}
        />
      </div>
      <YesNoDialog
        isOpen={openValidateDialog}
        title={'VALIDATION DIUO'}
        question={`Êtes-vous sûr de disposer de la dernière version du DIUO et de vouloir archiver le dossier ${dossierValue} ?`}
        handleYesClick={handleValidateDiuo}
        handleClose={() => setOpenValidateDialog(false)}
      />
      <YesNoDialog
        isOpen={openDialog}
        title={'SUPPRESSION DIUO'}
        question={`Êtes-vous sûr de vouloir supprimer le DIUO indice "${index}" du dossier ${dossierValue} ?`}
        handleYesClick={handleDeleteDiuo}
        handleClose={() => setOpenDialog(false)}
      />
    </>
  );
};

export default DiuoPage10;